import { useMemo } from 'react';

import { PackageEnum } from '../constants/enum';

const packagesMapConfig = window.GLOBAL_CONFIG?.mobileShop?.packagesMap || {};

const packagesMap = {
  [PackageEnum.LITE]: {
    code: packagesMapConfig[PackageEnum.LITE]?.code,
    name: '輕量版',
    shortName: '輕量',
    type: PackageEnum.LITE,
    price: packagesMapConfig[PackageEnum.LITE]?.price,
  },
  [PackageEnum.STANDARD]: {
    code: packagesMapConfig[PackageEnum.STANDARD]?.code,
    name: '標準版',
    shortName: '標準',
    type: PackageEnum.STANDARD,
    price: packagesMapConfig[PackageEnum.STANDARD]?.price,
  },
  [PackageEnum.PRO]: {
    code: packagesMapConfig[PackageEnum.PRO]?.code,
    name: '專業版',
    shortName: '專業',
    type: PackageEnum.PRO,
    price: packagesMapConfig[PackageEnum.PRO]?.price,
  },
};

export function usePackages() {
  const packages = useMemo(
    () => [PackageEnum.LITE, PackageEnum.STANDARD, PackageEnum.PRO].map((key) => packagesMap[key]),
    [],
  );

  return {
    packages,
    packagesMap,
  };
}
